import { usePress } from '@workramp/ui';
import AssetPickerTypes from '../asset-picker-types';
import LearningObjectIconTextPair from '../LearningObjectIconTextPair';

const AssetPickerCreateAsset = ({ type, onCreateClick }) => {
  const handleCreate = () => {
    onCreateClick(type);
  };

  const { pressProps } = usePress({
    onPress: handleCreate,
  });

  return (
    <li>
      <a className="asset-picker--create-asset" {...pressProps}>
        <LearningObjectIconTextPair type={type} text={AssetPickerTypes.getDisplayName(type)} onPress={handleCreate} />
      </a>
    </li>
  );
};

export default AssetPickerCreateAsset;
